import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "tips" }
const _hoisted_3 = {
  border: "true",
  style: {"width":"100%"},
  class: "table"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { colspan: "4" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { style: {"width":"30px"} }
const _hoisted_8 = { class: "itenName" }
const _hoisted_9 = {
  key: 0,
  title: "必选事项",
  class: "red"
}
const _hoisted_10 = {
  key: 1,
  title: "可选事项",
  class: "green"
}

import { reactive,watchEffect, toRefs } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'guide-item',
  props: {
    itemList:Array
},
  setup(__props, { expose: __expose }) {

const props = __props

const { itemList } = toRefs(props) as any

const data = reactive({
    checked:[] as any, //  判断选中的事项
    checkAll: false,
    isIndeterminate: true,
})

const getData = (length:number) => {
    data.checked = []
    for(let i = 0; i < length; i++){
        let temp = {} as any
        temp.key = i
        temp.status = false //  默认未选择
        temp.type = true    //  为true 则为可主动选择   为false 则为必选(用户不可改变状态)
        data.checked.push(temp)
    }
    initData()

}

const initData = () => {
    let length = itemList.value.length
    for(let i = 0; i < length; i++){
        if(itemList.value[i].type == 1){    //  为主事项 必选
            data.checked[i].type = false
            data.checked[i].status = true
        }

    }
}

const changeChecked = (n:number) => {
    if (itemList.value[n].type != 1 ){
        data.checked[n].status = !data.checked[n].status
    }
    let length = itemList.value.length
    let count = 0
    for (let i=0;i<length;i++){
        if (data.checked[i].status == true){
            count++
        }
    }
    if (count === length){
        data.checkAll = true
        data.isIndeterminate = false
    }else {
        data.checkAll = false
    }
}

const showChecked = () => {
    return data.checked
}
const showformatItemList = () => {
    return itemList.value
}
const handleCheckAllChange = (val:any) => {
    let length = itemList.value.length
    for(let i=0; i<length;i++){
        if (itemList.value[i].type != 1 ){
        data.checked[i].status = val
        }
    }
    data.isIndeterminate = false
}

watchEffect(() => {
    itemList.value
    getData(itemList.value.length) //  初始化选择框
})
__expose({
    showChecked,
    showformatItemList,
})

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("span", null, "备注：根据您选择的业务情形，涉及办理以下事项(主事项为必选，辅事项可以根据实际情况选择)；", -1)),
      _createVNode(_component_el_checkbox, {
        class: "select_all",
        indeterminate: data.isIndeterminate,
        modelValue: data.checkAll,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.checkAll) = $event)),
        onChange: handleCheckAllChange
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("全选", -1)
        ]))]),
        _: 1
      }, 8, ["indeterminate", "modelValue"])
    ]),
    _createElementVNode("table", _hoisted_3, [
      _cache[4] || (_cache[4] = _createElementVNode("colgroup", null, [
        _createElementVNode("col", { width: "100px" }),
        _createElementVNode("col", { width: "100px" }),
        _createElementVNode("col"),
        _createElementVNode("col", { width: "350px" })
      ], -1)),
      _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, " 选择 "),
          _createElementVNode("th", null, " 序号 "),
          _createElementVNode("th", null, " 事项名称 "),
          _createElementVNode("th", null, " 部门名称 ")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_unref(itemList).length === 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
              _createElementVNode("td", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_empty, {
                    "image-size": "100",
                    description: "暂无数据"
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(itemList), (value, n) => {
          return (_openBlock(), _createElementBlock("tr", {
            onClick: ($event: any) => (changeChecked(n))
          }, [
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "layer" }, null, -1)),
                _createVNode(_component_el_checkbox, {
                  modelValue: data.checked[n].status,
                  "onUpdate:modelValue": ($event: any) => ((data.checked[n].status) = $event),
                  disabled: data.checked[n].type == false
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ])
            ]),
            _createElementVNode("td", null, _toDisplayString(n+1), 1),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_8, [
                (value.type == 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "[必选]"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, "[可选]")),
                _createTextVNode(" " + _toDisplayString(value.data[0].serviceName), 1)
              ])
            ]),
            _createElementVNode("td", null, _toDisplayString(value.data[0].serviceDeptName), 1)
          ], 8, _hoisted_6))
        }), 256))
      ])
    ])
  ]))
}
}

})